import { ArrowRightOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface SectionProps {
  to?: string;
  title: string;
  loading?: boolean;
  childrens: ReactNode[];
}
export default function Section({
  title,
  childrens,
  loading = false,
  to = undefined,
}: SectionProps) {
  return (
    <div className='flex flex-col w-full pb-0 text-sm'>
      <div className='flex flex-row justify-between items-center mb-2'>
        <h4 className='text-xs text-content-minor m-0 mx-4'>{title}</h4>
        {to && (
          <Link to={to}>
            <Button
              type='link'
              className='!inline-flex !items-center !justify-center !text-primary !h-6 !text-sm'
            >
              voir <ArrowRightOutlined className='text-xs' />
            </Button>
          </Link>
        )}
      </div>
      <div className='flex flex-col'>
        <Spin spinning={loading}>
          {childrens.length === 0 ? (
            <p className='text-xl font-bold ml-4 opacity-10'>Aucun élément</p>
          ) : (
            childrens
          )}
        </Spin>
      </div>
    </div>
  );
}
